import { bindRoutineToReduxForm, createRoutine } from 'redux-saga-routines';
import { LIST_STANDARD, UPDATE_STANDARD } from './types';

export const listStandardHours = createRoutine(LIST_STANDARD);
export const updateStandardHours = createRoutine(UPDATE_STANDARD);
export const bindedUpdateStandardHours =
  bindRoutineToReduxForm(updateStandardHours);
